module.exports = __webpack_public_path__ + "img/snake-basictext.909537cd.webp";